import Grid from "@material-ui/core/Grid";
import React from "react";
import moment from "moment";
import _ from "lodash";

import RadioCard from "../../../../formElement/RadioCard";
import SelectFormElementV2 from "../../../../formElement/SelectFormElementV2";
import withStyles from "@material-ui/core/styles/withStyles";
import {isRequiredQuestion} from "../../../../../../../utils";
import styles from "./styles";

const RiskProfileSelectionStep = props => {
  const {
    classes,
    onAnswerChange,
    dataService,
    questions: [
      riskProfileRadioQuestion,
      riskProfileSelectQuestion,
    ],
  } = props;

  const riskProfiles = React.useMemo(() =>
    _.take(
      _.reverse(
        _.sortBy(dataService.riskProfiles, [
          (a) => moment(a.time.split(' ')[0]),
          (a) => a['SRRI-final']])).map(r => {
          return {
            id: r.customerRiskProfileGUID,
            value: r.customerRiskProfileGUID,
            label: "Vom {date} - Risikoklasse {score}"
              .replace("{date}", moment(r.time).format("DD.MM.YYYY"))
              .replace("{score}", r['SRRI-final'])
          }
        }), 10), []);

  const hasExistingProfiles = !_.isEmpty(riskProfiles);

  React.useEffect(() => {
    if (!riskProfileRadioQuestion.answer) {
      if (hasExistingProfiles) {
        handleRadioValueChange('select');
        handleProfileChange(getLatestRiskProfile())
      } else {
        handleRadioValueChange('new')
      }
    }
    if(!hasExistingProfiles){
      const infoText = 'Dieser Kunde/ diese Kundin hat noch keine Risikoprofilierung durchgeführt.';
      const existingProfileOption = riskProfileRadioQuestion.options[1];
      existingProfileOption.disabled = true;
      if(dataService.isNewDesign){
        existingProfileOption.disabledReason = infoText;
      } else {
        existingProfileOption.info_text = infoText;
      }
    } else if(!riskProfileSelectQuestion.answer){
      handleProfileChange(getLatestRiskProfile())
    }
  }, []);

  const handleProfileChange = (value) => {
    onAnswerChange(riskProfileSelectQuestion.uid, value);
  };

  const handleRadioValueChange = (value) => {
    onAnswerChange(riskProfileRadioQuestion.uid, value);
    riskProfileSelectQuestion.optional = (value === "new");
  };

  const getLatestRiskProfile = () => {
    return _.get(riskProfiles, '0.value', '')
  };

  return (
    <>
      <Grid container justify={dataService.isNewDesign ? "center" : undefined}>
        <Grid item xs={12} sm={5}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RadioCard
                label={riskProfileRadioQuestion.question_text}
                value={riskProfileRadioQuestion.answer || ''}
                options={riskProfileRadioQuestion.options}
                onChange={handleRadioValueChange}
                custom_classes={{radioGroupRoot: classes.radioGroupRoot, labelRoot: classes.labelRoot}}
                required={isRequiredQuestion(riskProfileRadioQuestion)}
                newDesign={dataService.isNewDesign}
              />
            </Grid>
            {hasExistingProfiles && (
              <Grid item xs={12}>
                <SelectFormElementV2
                  label={riskProfileSelectQuestion.question_text}
                  value={riskProfileSelectQuestion.answer}
                  options={riskProfiles}
                  onChange={handleProfileChange}
                  disabled={riskProfileRadioQuestion.answer === 'new'}
                  newDesign={dataService.isNewDesign}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};


export default withStyles(styles)(RiskProfileSelectionStep);